function IconBoxDiamondGreen() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M1 13V7V5C1 2.79086 2.79086 1 5 1H7H13V7V9C13 11.2091 11.2091 13 9 13H7H1Z" fill="#99FFDD" />
            <path d="M7 1H5C2.79086 1 1 2.79086 1 5V7M7 1H13V7M7 1V13M1 7V13H7M1 7H13M13 7V9C13 11.2091 11.2091 13 9 13H7" stroke="#0A255C" />
        </svg>
    )
}

export default IconBoxDiamondGreen